const REFERRAL_STORAGE_KEY = "codeape.referralCode.v1";
const REFERRAL_CODE_PATTERN = /^APE-[A-HJ-NP-Z2-9]{6}$/;

export function normalizeReferralCode(value: string | null | undefined): string | null {
  const normalized = (value ?? "").trim().toUpperCase();
  return REFERRAL_CODE_PATTERN.test(normalized) ? normalized : null;
}

export function readReferralCodeFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  return normalizeReferralCode(params.get("ref") || params.get("r"));
}

export function readStoredReferralCode(): string | null {
  try {
    return normalizeReferralCode(window.localStorage.getItem(REFERRAL_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function persistReferralCode(code: string): void {
  const normalized = normalizeReferralCode(code);
  if (!normalized) return;
  try {
    window.localStorage.setItem(REFERRAL_STORAGE_KEY, normalized);
  } catch {
    // Storage can be disabled in private browsers. The current URL still carries the code.
  }
}

export function readActiveReferralCode(search: string): string | null {
  const fromUrl = readReferralCodeFromSearch(search);
  if (fromUrl) {
    persistReferralCode(fromUrl);
    return fromUrl;
  }
  return readStoredReferralCode();
}

export function referralPath(path: string, code: string | null): string {
  const normalized = normalizeReferralCode(code);
  if (!normalized) return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}ref=${encodeURIComponent(normalized)}`;
}
